import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import GraphqlOperationCatalog from "./GraphqlOperationCatalog";
import SchemaBrowser from "./SchemaBrowser";

export default function ExplorerSidebar({
  sidebarTab,
  onSidebarTabChange,
  operations,
  selectedOp,
  onSelectOp,
  schemaTree,
  onSelectSchemaOperation,
  onInsertField,
  history,
  onSelectHistory,
  sdlSource,
}) {
  return (
    <aside className="gql-sidebar">
      <Box className="gql-sidebar-tabs">
        {[
          { id: "operations", label: "Operaciones" },
          { id: "schema", label: "Schema" },
          { id: "history", label: "Historial" },
        ].map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`gql-sidebar-tab ${sidebarTab === tab.id ? "active" : ""}`}
            onClick={() => onSidebarTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </Box>

      <Box className="gql-sidebar-content">
        {sidebarTab === "operations" && (
          <GraphqlOperationCatalog
            operations={operations}
            selected={selectedOp}
            onSelect={onSelectOp}
          />
        )}
        {sidebarTab === "schema" && (
          <SchemaBrowser
            schemaTree={schemaTree}
            onSelectOperation={onSelectSchemaOperation}
            onInsertField={onInsertField}
            sdlSource={sdlSource}
          />
        )}
        {sidebarTab === "history" && (
          <Box className="gql-history">
            {!history?.length && (
              <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
                Sin historial en esta sesión.
              </Typography>
            )}
            {history?.map((entry, idx) => (
              <button
                key={`${entry.at}-${idx}`}
                type="button"
                className="gql-history-item"
                onClick={() => onSelectHistory(entry)}
              >
                <span className="gql-history-time">
                  {new Date(entry.at).toLocaleTimeString()}
                </span>
                <code>{entry.query.split("\n")[0].slice(0, 60)}…</code>
              </button>
            ))}
          </Box>
        )}
      </Box>
    </aside>
  );
}
